import { FiLayout, FiBook, FiVideo, FiMonitor, FiCpu, FiUsers, FiTrendingUp, FiTarget, FiZap, FiLayers, FiAward, FiFileText, FiHome, FiDollarSign, FiClipboard, FiCheckSquare, FiPackage } from 'react-icons/fi';

export const digitalProducts = [
    // ==========================================
    // MENTORSHIP RECORDING BUNDLES
    // ==========================================
    {
        id: 'bundle-q1-2025',
        title: 'Q1 2025 Mentorship Recordings',
        description: '12 weekly mentorship recordings from January-March 2025. Live deal breakdowns, market analysis, and Q&A sessions.',
        price: 297,
        image: 'https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?auto=format&fit=crop&q=80&w=800',
        category: 'education',
        featured: true,
        features: ['12 HD Video Sessions', 'Deal Breakdowns', 'Market Analysis', 'Live Q&A Archives', 'Downloadable Audio', 'Lifetime Access'],
        slug: 'q1-2025-mentorship-bundle'
    },
    {
        id: 'bundle-2024-complete',
        title: '2024 Complete Recording Library',
        description: 'All 52 weekly mentorship recordings from 2024. The ultimate archive of Tom\'s live coaching sessions.',
        price: 997,
        image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=800',
        category: 'education',
        featured: true,
        topRated: true,
        features: ['52 HD Video Sessions', 'Full Year Access', 'Deal Reviews', 'Market Updates', 'Student Success Stories', 'Bonus Q&A Compilations'],
        slug: '2024-complete-library'
    },
    {
        id: 'bundle-flip-series',
        title: 'Flip From Start to Finish Series',
        description: '8-part video series following a complete house flip from acquisition to sale. Real numbers, real lessons.',
        price: 197,
        image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=800',
        category: 'education',
        topRated: true,
        features: ['8 Episode Series', 'Acquisition Strategy', 'Rehab Management', 'Contractor Negotiations', 'Staging & Sale', 'Profit Breakdown'],
        slug: 'flip-start-to-finish'
    },
    {
        id: 'bundle-wholesale-series',
        title: 'Wholesale Mastery Series',
        description: '6-part deep dive on finding, negotiating, and assigning wholesale deals. No money down strategies.',
        price: 149,
        image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800',
        category: 'education',
        features: ['6 Video Modules', 'Finding Motivated Sellers', 'Negotiation Scripts', 'Contract Templates', 'Assignment Strategies', 'Case Studies'],
        slug: 'wholesale-mastery'
    },

    // ==========================================
    // TOOLS & CALCULATORS
    // ==========================================
    {
        id: 'tool-deal-analyzer',
        title: 'Flip Deal Analyzer Pro',
        description: 'The exact Excel spreadsheet Tom uses to analyze every flip. Calculates ARV, repair costs, profit margins, and ROI.',
        price: 49,
        image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        featured: true,
        features: ['ARV Calculator', 'Repair Cost Estimator', 'Holding Cost Tracker', 'Profit Margin Analysis', 'ROI Calculator', 'Video Tutorial'],
        slug: 'deal-analyzer-pro'
    },
    {
        id: 'tool-rehab-budget',
        title: 'Rehab Budget Estimator',
        description: 'Room-by-room rehab cost estimator with current material and labor prices. Never overpay for a rehab again.',
        price: 39,
        image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        features: ['Room-by-Room Costs', 'Material Calculator', 'Labor Estimates', 'Regional Adjustments', 'Contingency Planning', 'Printable Reports'],
        slug: 'rehab-budget-estimator'
    },
    {
        id: 'tool-arv-calculator',
        title: 'ARV & Comps Calculator',
        description: 'Systematic approach to calculating After Repair Value using comparable sales. Plus a training video on pulling comps.',
        price: 29,
        image: 'https://images.unsplash.com/photo-1460472178825-e5240623afd5?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        features: ['Comp Analysis Template', 'ARV Formula', 'Adjustment Factors', 'Training Video', 'Market Data Sources', 'Printable Worksheets'],
        slug: 'arv-comps-calculator'
    },

    // ==========================================
    // CHECKLISTS & GUIDES
    // ==========================================
    {
        id: 'checklist-flip-complete',
        title: 'Complete House Flipping Checklist',
        description: 'The 127-point checklist Tom uses on every flip. From due diligence to closing day.',
        price: 29,
        image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?auto=format&fit=crop&q=80&w=800',
        category: 'digital-products',
        topRated: true,
        features: ['127 Checkpoint Items', 'Due Diligence Phase', 'Acquisition Checklist', 'Rehab Management', 'Listing Prep', 'Closing Procedures'],
        slug: 'flip-checklist-complete'
    },
    {
        id: 'checklist-inspection',
        title: 'Property Inspection Walkthrough',
        description: 'What to look for when walking a potential flip. Foundation to roof, plus red flags that kill deals.',
        price: 19,
        image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&q=80&w=800',
        category: 'digital-products',
        features: ['Exterior Inspection', 'Interior Checklist', 'Major Systems Review', 'Red Flag Indicators', 'Photo Documentation', 'Repair Priority Matrix'],
        slug: 'property-inspection-guide'
    },
    {
        id: 'checklist-due-diligence',
        title: 'Due Diligence Checklist',
        description: 'Everything to verify before closing on a property. Title, liens, permits, zoning, and more.',
        price: 19,
        image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800',
        category: 'digital-products',
        features: ['Title Search Guide', 'Lien Verification', 'Permit History', 'Zoning Confirmation', 'Insurance Requirements', 'Closing Prep'],
        slug: 'due-diligence-checklist'
    },

    // ==========================================
    // CONTRACT TEMPLATES
    // ==========================================
    {
        id: 'templates-contract-bundle',
        title: 'Investor Contract Bundle',
        description: '15 essential contracts for flipping and wholesaling. Purchase agreements, assignments, contractor agreements, and more.',
        price: 149,
        image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        featured: true,
        features: ['Purchase Agreement', 'Assignment Contract', 'Wholesale Agreement', 'Contractor Agreement', 'Scope of Work', 'Lien Waiver Forms'],
        slug: 'investor-contract-bundle'
    },
    {
        id: 'templates-contractor',
        title: 'Contractor Agreement Pack',
        description: 'Protect yourself with proper contractor documentation. Agreements, scope of work, payment schedules, lien waivers.',
        price: 49,
        image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        features: ['Master Agreement', 'Scope of Work Template', 'Payment Schedule', 'Change Order Form', 'Lien Waiver', 'Completion Certificate'],
        slug: 'contractor-agreement-pack'
    },

    // ==========================================
    // SCRIPTS & SYSTEMS
    // ==========================================
    {
        id: 'scripts-seller',
        title: 'Seller Negotiation Scripts',
        description: '12 proven scripts for talking to motivated sellers. Cold calls, follow-ups, objection handling, and closing.',
        price: 39,
        image: 'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?auto=format&fit=crop&q=80&w=800',
        category: 'digital-products',
        features: ['Cold Call Script', 'Warm Lead Script', 'Objection Handlers', 'Price Negotiation', 'Follow-up Sequences', 'Closing Scripts'],
        slug: 'seller-scripts'
    },
    {
        id: 'system-deal-finder',
        title: 'Deal Finding System',
        description: 'The complete system for finding off-market properties. Driving for dollars, lists, direct mail, and digital marketing.',
        price: 79,
        image: 'https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?auto=format&fit=crop&q=80&w=800',
        category: 'digital-products',
        topRated: true,
        features: ['Driving for Dollars SOP', 'Skip Tracing Guide', 'Direct Mail Templates', 'List Building Criteria', 'CRM Setup Guide', 'Follow-up Automations'],
        slug: 'deal-finding-system'
    },

    // ==========================================
    // COURSES
    // ==========================================
    {
        id: 'course-flip-fundamentals',
        title: 'House Flipping Fundamentals',
        description: 'Complete video course on flipping houses. 8 modules covering everything from finding deals to collecting your check.',
        price: 497,
        image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=800',
        category: 'education',
        featured: true,
        features: ['8 Video Modules', 'Downloadable Resources', 'Deal Analyzer Tool', 'Private Community Access', 'Monthly Q&A Call', 'Lifetime Updates'],
        slug: 'flip-fundamentals-course',
        packages: [
            { name: 'Self-Study', price: 497, deliveryDays: 0, description: 'Course only', features: ['8 Video Modules', 'All Resources', 'Community Access', 'Email Support'] },
            { name: 'Coached', price: 997, deliveryDays: 0, description: 'Course + coaching', features: ['Everything in Self-Study', '3 Coaching Calls', 'Deal Reviews', 'Priority Support'], popular: true },
            { name: 'VIP', price: 2497, deliveryDays: 0, description: 'Full mentorship', features: ['Everything in Coached', 'Weekly Calls for 3 Months', 'Direct Phone Access', 'Joint Venture Opportunity'] }
        ]
    },
    {
        id: 'course-creative-finance',
        title: 'Creative Financing Mastery',
        description: 'How to acquire properties with little to no money down. Subject-to, seller financing, lease options, and more.',
        price: 397,
        image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=800',
        category: 'education',
        topRated: true,
        features: ['6 Video Modules', 'Contract Templates', 'Case Studies', 'Seller Scripts', 'Due Diligence Guide', 'Legal Considerations'],
        slug: 'creative-financing-course'
    },

    // ==========================================
    // BUNDLES
    // ==========================================
    {
        id: 'bundle-starter-kit',
        title: 'Beginner Flipper Starter Kit',
        description: 'Everything a new investor needs to analyze, acquire, and flip their first property. Best value for beginners.',
        price: 197,
        image: 'https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        featured: true,
        topRated: true,
        features: ['Deal Analyzer Pro', 'Flipping Checklist', 'Inspection Guide', 'Contract Bundle', 'Seller Scripts', 'ARV Calculator'],
        slug: 'beginner-starter-kit'
    },
    {
        id: 'bundle-wholesale-toolkit',
        title: 'Wholesale Deal Machine',
        description: 'Complete toolkit for finding and flipping contracts. Everything you need to start wholesaling today.',
        price: 149,
        image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800',
        category: 'templates',
        features: ['Deal Finding System', 'Seller Scripts', 'Assignment Contracts', 'Buyer List Builder', 'Follow-up Templates', 'Closing Checklist'],
        slug: 'wholesale-toolkit'
    },

    // ==========================================
    // CONSULTATION
    // ==========================================
    {
        id: 'consultation-call',
        title: 'Strategy Call with Tom',
        description: 'One-on-one call to discuss your real estate goals, review deals, or get unstuck on your investing journey.',
        price: 0,
        image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&q=80&w=800',
        category: 'services',
        featured: true,
        features: ['Video Call', 'Screen Share', 'Recording Available', 'Follow-up Email', 'Action Items', 'Calendar Integration'],
        slug: 'strategy-call',
        isBookingProduct: true,
        packages: [
            { name: 'Discovery', price: 0, deliveryDays: 1, description: '15-minute intro call', features: ['15 Minute Call', 'Quick Q&A', 'Fit Assessment', 'Next Steps'] },
            { name: 'Deal Review', price: 150, deliveryDays: 3, description: '45-minute deal analysis', features: ['45 Minute Session', 'Deal Breakdown', 'Numbers Review', 'Recording', 'Action Items'], popular: true },
            { name: 'VIP Day', price: 997, deliveryDays: 14, description: 'Half-day intensive', features: ['4-Hour Session', 'Priority Booking', 'Full Business Review', 'Custom Roadmap', '30-Day Support', 'Recording'] }
        ],
        extras: [
            { id: 'recording', title: 'Call recording', description: 'Get a recording of our call', price: 25 },
            { id: 'priority-booking', title: 'Priority booking', description: 'Book within the next 48 hours', price: 50 },
            { id: 'follow-up', title: 'Extended follow-up', description: '1-week email support after call', price: 75 }
        ]
    }
];

// Category definitions for the shop
export const categories = [
    { id: 'all', label: 'All Products' },
    { id: 'education', label: 'Courses & Training' },
    { id: 'templates', label: 'Tools & Templates' },
    { id: 'digital-products', label: 'Checklists & Guides' },
    { id: 'services', label: 'Coaching' }
];

// Services section (for /services page, not shop)
export const services = [
    {
        id: 's1',
        title: 'Bronze Mentorship',
        description: 'Group coaching and community access for new investors.',
        icon: FiUsers,
        tiers: [
            {
                name: 'Bronze',
                price: '497',
                unit: 'per month',
                description: 'Weekly group calls and community access.',
                features: ['Weekly Group Calls', 'Private Community', 'Deal Analysis Templates', 'Resource Library']
            }
        ]
    },
    {
        id: 's2',
        title: 'Silver Mentorship',
        description: 'More personalized guidance with monthly 1-on-1 sessions.',
        icon: FiTarget,
        tiers: [
            {
                name: 'Silver',
                price: '1,497',
                unit: 'per month',
                description: 'Everything in Bronze plus personal coaching.',
                features: ['Everything in Bronze', 'Monthly 1-on-1 Call', 'Deal Reviews', 'Priority Support'],
                isPopular: true
            }
        ]
    },
    {
        id: 's3',
        title: 'Gold & Platinum',
        description: 'Intensive partnership for serious investors.',
        icon: FiAward,
        tiers: [
            {
                name: 'Gold / Platinum',
                price: 'Apply',
                unit: 'contact us',
                description: 'Direct access and joint venture opportunities.',
                features: ['Weekly 1-on-1 Calls', 'Direct Phone Access', 'JV Opportunities', 'On-site Visits']
            }
        ]
    }
];
